import { matchesTemplate } from './matchesTemplate';
import { REALTIME_CONFIGURATION_TEMPLATES } from './templates';

export const isInRealtimeTemplates = (filters: string) => {
  return Object.values(REALTIME_CONFIGURATION_TEMPLATES).some((template) => {
    return matchesTemplate(template, filters);
  });
};
